/* globals  AspNetCoreConfiguration */
export default {};
export const API_URL = "/api";
export const APP_ORIGIN = "AspNetCoreConfiguration.appOrigin";
